if (!customElements.get('cross-sell-modal')) {
  customElements.define(
    'cross-sell-modal',
    class CrossSellModal extends ModalDialog {
      constructor() {
        super();

        this.querySelectorAll('[data-cross-sell-dismiss]').forEach((button) =>
          button.addEventListener('click', () => this.hide())
        );

        this.initDots();

        // Close the modal when a product has been added to the cart from
        // within it, so the cart notification/drawer can take over.
        // The pub/sub event is published synchronously before the cart
        // drawer/notification renders, so the modal is gone by the time
        // the drawer opens.
        subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (event.source === 'product-form' && this.hasAttribute('open')) this.hide(true);
        });
      }

      initDots() {
        const slider = this.querySelector('slider-component');
        const dots = Array.from(this.querySelectorAll('.cross-sell-modal__dot'));
        if (!slider || !dots.length) return;

        slider.addEventListener('slideChanged', (event) => {
          dots.forEach((dot, index) => {
            const isActive = index === event.detail.currentPage - 1;
            dot.classList.toggle('cross-sell-modal__dot--active', isActive);
            if (isActive) {
              dot.setAttribute('aria-current', 'true');
            } else {
              dot.removeAttribute('aria-current');
            }
          });
        });

        dots.forEach((dot, index) => {
          dot.addEventListener('click', () => {
            if (slider.sliderItemOffset) slider.setSlidePosition(index * slider.sliderItemOffset);
          });
        });
      }

      hide(preventFocus = false) {
        const cartElement = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartElement) cartElement.setActiveElement(this.openedBy);
        if (preventFocus) this.openedBy = null;
        super.hide();
      }
    }
  );
}
